import { cx } from "@/utils";
import { Item } from "@radix-ui/react-dropdown-menu";

import Clickable, { ClickableProps } from "../Clickable";

import styles from "./Dropdown.module.css";

type DropdownItemProps = ClickableProps & { target?: string };

/**
 * DropdownItem
 * Renders a button or link, needs to be inside of a DropdownMenu and a Dropdown to work.
 */

const DropdownItem: React.FC<DropdownItemProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <Item className={cx(styles.base, styles.item, className)} asChild>
      <Clickable {...props}>{children}</Clickable>
    </Item>
  );
};

export default DropdownItem;
